import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './App.css';
import './aspetto.css';
import './theme-tokens.css';
import { initTheme } from './theme';

initTheme();   // applica accento + modo (chiaro/scuro/sistema) prima del render

const root = createRoot(document.getElementById('root'));
root.render(<App />);
